import { fetchSubStations } from "../network/Network";
import { OUTBOUND_FILTER_STATE_KEY } from "../util/LocalStorageKey";
import {
  getFromLocalStorage,
  saveIntoLocalStorage,
} from "../../overview/utils/utils";
import { getStationCode } from "../../network/NetworkUtil";

export const OutboundFilterReducer = (state, action) => {
  const saveFilterState = (newState) => {
    const record = JSON.stringify({
      data: newState,
      stationCode: getStationCode(),
    });
    saveIntoLocalStorage(OUTBOUND_FILTER_STATE_KEY, record);
  };

  const readFilterState = () => {
    try {
      const json = getFromLocalStorage(OUTBOUND_FILTER_STATE_KEY) || null;
      if (json) {
        const record = JSON.parse(json);
        if (record.stationCode === getStationCode()) {
          return record.data;
        }
      }
    } catch (ignored) {}
    return null;
  };

  switch (action.type) {
    case "RECEIVE_FILTER_DATA": {
      const newState = { ...state, data: { ...state.data, ...action.data } };
      saveFilterState(newState);
      return newState;
    }
    case "SELECT_CLUSTER": {
      const newState = { ...state, cluster: action.Cluster };
      saveFilterState(newState);
      return newState;
    }
    case "SELECT_DRIVER_TYPE": {
      const newState = { ...state, driverType: action.DriverType };
      saveFilterState(newState);
      return newState;
    }
    case "SELECT_SHIPMENT_TYPE": {
      const newState = { ...state, shipmentType: action.ShipmentType };
      saveFilterState(newState);
      return newState;
    }
    case "SELECT_DEPARTURE": {
      const newState = { ...state, departure: action.Departure };
      saveFilterState(newState);
      return newState;
    }
    case "SELECT_SPR_TIME_LIMIT": {
      const newState = { ...state, sprTimeLimit: action.sprTimeLimit };
      saveFilterState(newState);
      return newState;
    }
    case "SELECT_SPR_PACKAGE_COUNT": {
      const newState = { ...state, sprPackageCount: action.sprPackageCount };
      saveFilterState(newState);
      return newState;
    }
    case "SELECT_RC_TIME_LIMIT": {
      const newState = { ...state, rcTimeLimit: action.rcTimeLimit };
      saveFilterState(newState);
      return newState;
    }
    case "SELECT_RC_PACKAGE_COUNT": {
      const newState = { ...state, rcPackageCount: action.rcPackageCount };
      saveFilterState(newState);
      return newState;
    }
    case "UNLOAD_VIEW":
      return state;
    case "SELECT_WAVE_VIEW": {
      const newState = { ...state, waveViewType: action.waveViewType };
      saveFilterState(newState);
      return newState;
    }
    case "REMOVE_FILTER": {
      const { key, value } = action.data;
      state[key] = state[key].filter((item) => item !== value);
      const newItem = state[key].filter((item) => item !== value);
      const newState = { ...state, [key]: newItem };
      saveFilterState(newState);
      return newState;
    }
    case "LOAD_XPT_NODES":
      const { dispatcher, baseUrl, capability, stationConfig } = action.data;
      fetchSubStations(dispatcher, baseUrl, capability, stationConfig);
      return state;
    case "REMOVE_ALL_FILTER": {
      const newState = { ...state };
      Object.entries(state).forEach((entry) => {
        const key = entry[0];
        const values = entry[1];
        if (Array.isArray(values) && values.length && key !== "data") {
          newState[key] = [];
        }
      });
      saveFilterState(newState);
      return newState;
    }
    case "RECEIVE_XPT_NODES": {
      const { xptNodes } = action.data;
      let newState = { ...state, xptNodes, data: { ...state.data, xptNodes } };
      saveFilterState(newState);
      return newState;
    }
    case "SELECT_XPT_NODE": {
      const newState = { ...state, xptNodes: action.xptNodes };
      saveFilterState(newState);
      return newState;
    }
    case "SELECT_WINDOW": {
      const newState = { ...state, deliveryWindow: action.DeliveryWindow };
      saveFilterState(newState);
      return newState;
    }
    case "SELECT_ANCHOR_POINT": {
      const newState = { ...state, sourceNode: action.sourceNode };
      saveFilterState(newState);
      return newState;
    }
    case "SELECT_CPT_TIME_LIMIT": {
      const newState = { ...state, cptTimeLimit: action.cptTimeLimit };
      saveFilterState(newState);
      return newState;
    }
    case "LOAD_FILTERS": {
      const savedState = readFilterState();
      if (savedState) {
        return {
          ...state,
          ...savedState,
        };
      }
      return state;
    }
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./src/components/outboundAmzl/reducers/OutboundFilterReducer.js